<template>
  <el-dialog
    append-to-body
    ref="merchantRuleDetal"
    width="50%"
    :title="title"
    :before-close="handleClose"
    :visible.sync="visible"
    fullscreen
  >
    <!-- 地图输入框 -->
    <div class="pickerBox">
      <div style="display: flex; justify-content: center">
        <el-input
          id="tipinput"
          v-model="searchValue"
          placeholder="请输入站点详细地址"
          style="width: 28vw"
        />
      </div>
    </div>
    <!-- 地图 -->
    <div id="amapContainer" class="map"> </div>
    <!-- 规则列表 -->
    <div style="display: flex; justify-content: space-around">
      <el-table
        :data="list.addMerchantPriceStationRuleAreaVoList"
        :span-method="objectSpanMethod"
        border
        style="width: 85%"
        size="mini"
      >
        <el-table-column prop="areaCoverageName" align="center" label="服务区域">
          <template scope="scope">
            <div :style="!scope.row.stationName && !scope.row.pickUpRule ? 'color:#f56c6c;' : ''">
              {{ scope.row.areaCoverageName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="计价方式">
          <template scope="scope">
            <div style="text-align: left">
              <div v-if="scope.row.carpoolStr">
                {{ scope.row.carpoolStr }}
              </div>
              <div v-if="scope.row.exclusiveStr">
                {{ scope.row.exclusiveStr }}
              </div>
            </div>

            <div v-if="!scope.row.carpoolStr">——</div>
          </template>
        </el-table-column>
        <el-table-column prop="pickUpRule" label="接送方式" align="center">
          <template scope="scope">
            <div v-if="scope.row.pickUpRule">
              <div v-if="scope.row.pickUpRule === 1">摆渡车接</div>
              <div v-if="scope.row.pickUpRule === 2">城际车接</div>
            </div>
            <div v-else>——</div>
          </template>
        </el-table-column>
        <el-table-column label="接人时间" align="center" width="150">
          <template scope="scope">
            <div class="time" v-if="scope.row.pickUpTime">
              <span>提前 </span>
              <span>{{ scope.row.pickUpTime }}</span>
              <span> 分钟接人</span>
            </div>
            <div v-else>——</div>
          </template>
        </el-table-column>
        <el-table-column label="停售时间" align="center">
          <template scope="scope">
            <div class="time" v-if="scope.row.closingTime">
              <span>{{ scope.row.closingTime }}</span>
              <span> 分钟</span>
            </div>
            <div v-else>——</div>
          </template>
        </el-table-column>
        <el-table-column label="分流站点" align="center">
          <template scope="scope">
            <div v-if="scope.row.stationName">{{ scope.row.stationName }}</div>
            <div v-else>———</div>
          </template>
        </el-table-column>
        <el-table-column label="权重" align="center">
          <template scope="scope">
            <div v-if="scope.row.weight !== null">{{ scope.row.weight }}</div>
            <div v-else>———</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="地图显示">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isOpen"
              active-color="#13ce66"
              inactive-color="#BFBFBF"
              @change="mapChange(scope.$index, scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    data() {
      return {
        placeSearch: null,
        searchValue: '',
        visible: true,
        title: '',
        list: [],
        path: []
        // zoom: 12,
        // center: [102.719273, 25.011719],
      }
    },
    methods: {
      // 地图的显示
      mapChange(index, row) {
        const path = this.path
        const list = this.list
        if (row.isOpen) {
          list.addMerchantPriceStationRuleAreaVoList[index].areaCoverageName =
            list.addMerchantPriceStationRuleAreaVoList[index].areaCoverageName + ' '
        } else {
          list.addMerchantPriceStationRuleAreaVoList[index].areaCoverageName =
            list.addMerchantPriceStationRuleAreaVoList[index].areaCoverageName + ' '
        }
        path.forEach((item, num) => {
          if (index === num) {
            item.isShow = row.isOpen
            item.stationName = row.stationName
            item.pickUpRule = row.pickUpRule
          }
        })
        this.path = path
        this.initMap(() => {
          for (var i = 0; i < path.length; i++) {
            if (path[i].isShow) {
              this.initPolygonAmap(path[i].pashList, path[i].stationName, path[i].pickUpRule)
            }
          }
        })
        this.list = list
      },
      // 预览规则
      edit(row) {
        this.visible = true
        this.title = '查看接送区域'
        const path = []
        row.addMerchantPriceStationRuleAreaVoList.forEach((item) => {
          const first = []
          item.areaCoveragePointList.forEach((obj) => {
            first.push([obj.longitude, obj.latitude])
          })
          const obj = {
            pashList: first,
            isShow: true,
            stationName: item.stationName,
            pickUpRule: item.pickUpRule
          }
          path.push(obj)
        })
        this.list = row
        this.path = path
        this.initMap(() => {
          setTimeout(() => {
            for (var i = 0; i < path.length; i++) {
              if (path[i].isShow) {
                this.initPolygonAmap(path[i].pashList, path[i].stationName, path[i].pickUpRule)
              }
            }
          }, 100)
        })
      },
      // 获取矢量图形
      async initPolygonAmap(paths, stationName, pickUpRule) {
        this.AMap = window.AMap
        const polygon = new this.AMap.Polygon({
          map: this.map,
          path: paths,
          fillOpacity: 0.5,
          fillColor: stationName ? '#079c42' : pickUpRule ? '#2c94ff' : '#ff2929',
          strokeColor: stationName ? '#01a534' : pickUpRule ? '#0E75E4' : '#ff0000',
          strokeWeight: 2,
          strokeOpacity: 1,
          strokeStyle: 'dashed',
          zIndex: 50
        })
        // 缩放地图到合适的视野级别
        this.map.setFitView([polygon])
      },
      // 初始化地图
      initMap(callBack) {
        this.AMap = window.AMap
        // var autoOptions = {
        //   input: "tipinput"
        // };
        this.AMap.plugin(['AMap.PlaceSearch', 'AMap.AutoComplete', 'AMap.ControlBar'], function () {
          // TODO  创建控件并添加
        })
        this.map = new this.AMap.Map('amapContainer', {
          zoom: 10,
          pitch: 80,
          rotation: 0,
          buildingAnimation: false // 楼块出现是否带动画
        })
        const autoOptions = {
          input: 'tipinput'
        }
        const auto = new this.AMap.Autocomplete(autoOptions)
        this.placeSearch = new this.AMap.PlaceSearch({
          map: this.map
        })
        this.AMap.event.addListener(auto, 'select', this.onSearchResult)
        this.map.addControl(new this.AMap.ControlBar())
        if (callBack && typeof callBack == 'function') {
          callBack()
        }
      },
      // 搜索
      onSearchResult(e) {
        this.placeSearch.setCity(e.poi.adcode)
        this.placeSearch.search(e.poi.name)
      },
      handleClose() {
        this.visible = false
        this.searchValue = ''
      }
    }
  }
</script>
<style>
  .amap-sug-result {
    z-index: 999999999 !important;
  }
</style>
<style scoped>
  .pickerBox {
    position: absolute;
    z-index: 99999999;
    top: 110px;
    left: 30px;
    width: 40%;
  }

  .time {
    display: flex;
    align-items: center;
  }
  .time ::v-deep .el-input__inner {
    padding: 0 8px;
    border: none;
    border-bottom: 1px solid #000000;
    border-radius: 0;
    height: 20px;
  }
  .map {
    height: 65vh;
    margin-bottom: 20px;
  }
</style>
